import api from './client';
import type {
  SuccessCaseListItem,
  SuccessCaseResponse,
  SuccessCaseCreate,
  SuccessCaseUpdate,
  SuccessCaseSummary,
} from '@/types/data';

export const successCasesApi = {
  // 成功事例一覧を取得
  list: async (params: {
    company_id: number;
    category?: string;
    metric_type?: string;
    include_public?: boolean;
    limit?: number;
    offset?: number;
  }): Promise<SuccessCaseListItem[]> => {
    const response = await api.get<SuccessCaseListItem[]>('/api/success-cases', { params });
    return response.data;
  },

  // 成功事例サマリーを取得
  getSummary: async (params: {
    company_id: number;
    include_public?: boolean;
  }): Promise<SuccessCaseSummary> => {
    const response = await api.get<SuccessCaseSummary>('/api/success-cases/summary', { params });
    return response.data;
  },

  // 類似事例を検索
  findSimilar: async (params: {
    company_id: number;
    category?: string;
    metric_type?: string;
    tags?: string;
    min_improvement_rate?: number;
    limit?: number;
  }): Promise<SuccessCaseListItem[]> => {
    const response = await api.get<SuccessCaseListItem[]>('/api/success-cases/similar', { params });
    return response.data;
  },

  // 成功事例を自動検出
  autoDetect: async (params: {
    company_id: number;
    period_days?: number;
    min_improvement_percent?: number;
  }): Promise<SuccessCaseCreate[]> => {
    const response = await api.post<SuccessCaseCreate[]>('/api/success-cases/auto-detect', null, { params });
    return response.data;
  },

  // 成功事例を取得
  get: async (caseId: number): Promise<SuccessCaseResponse> => {
    const response = await api.get<SuccessCaseResponse>(`/success-cases/${caseId}`);
    return response.data;
  },

  // 成功事例を作成
  create: async (data: SuccessCaseCreate): Promise<SuccessCaseResponse> => {
    const response = await api.post<SuccessCaseResponse>('/api/success-cases', data);
    return response.data;
  },

  // 成功事例を更新
  update: async (caseId: number, data: SuccessCaseUpdate): Promise<SuccessCaseResponse> => {
    const response = await api.put<SuccessCaseResponse>(`/success-cases/${caseId}`, data);
    return response.data;
  },

  // 成功事例を削除
  delete: async (caseId: number): Promise<void> => {
    await api.delete(`/success-cases/${caseId}`);
  },
};
